"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5818],{

/***/ 88610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* reexport */ CheckIcon; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Icons/CheckIcon.tsx


var _excluded = ["color"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var CheckIcon = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#52BD94" : _ref$color,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", _objectSpread(_objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), {}, {
    ref: ref,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0C5.37 0 0 5.37 0 12ZM16.935 7.935C17.205 7.665 17.58 7.5 18 7.5C18.825 7.5 19.5 8.175 19.5 9C19.5 9.42 19.335 9.795 19.065 10.065L11.565 17.565C11.295 17.835 10.92 18 10.5 18C10.08 18 9.705 17.835 9.435 17.565L4.935 13.065C4.665 12.795 4.5 12.42 4.5 12C4.5 11.175 5.175 10.5 6 10.5C6.42 10.5 6.795 10.665 7.065 10.935L10.5 14.385L16.935 7.935Z",
      fill: color
    })
  }));
});
CheckIcon.displayName = "TablePricing.CheckIcon";
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Icons/index.ts


/***/ }),

/***/ 16410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body; },
  "bL": function() { return /* reexport */ Cell_Cell; },
  "O7": function() { return /* reexport */ EmptyRow; },
  "h4": function() { return /* reexport */ Header; },
  "qN": function() { return /* reexport */ HeaderCell_HeaderCell; },
  "X2": function() { return /* reexport */ Row; },
  "yD": function() { return /* reexport */ RowHeader_RowHeader; },
  "Do": function() { return /* reexport */ RowSubHeader_RowSubHeader; },
  "M$": function() { return /* reexport */ SectionHeader_SectionHeader; },
  "ZP": function() { return /* reexport */ TablePricing; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useResizeObserver/index.ts + 1 modules
var useResizeObserver = __webpack_require__(73889);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TableBasic/useTableBasic.ts



var useTableBasic = function useTableBasic(_ref) {
  var _tableRef$current;

  var table = _ref.table;

  var _useState = (0,react.useState)(false),
      stickyHeader = _useState[0],
      setStickyHeader = _useState[1];

  var _useState2 = (0,react.useState)(false),
      stickySidebar = _useState2[0],
      setStickySidebar = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      tableRef = _useState3[0],
      setTableRef = _useState3[1];

  var checkIfHeaderIsSticky = (0,react.useCallback)(function () {
    var _table$current, _table$current2, _table$current2$paren, _table$current2$paren2;

    var tableHeight = Number(table === null || table === void 0 ? void 0 : (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.getBoundingClientRect().height);
    var wrapperHeight = Number((_table$current2 = table.current) === null || _table$current2 === void 0 ? void 0 : (_table$current2$paren = _table$current2.parentElement) === null || _table$current2$paren === void 0 ? void 0 : (_table$current2$paren2 = _table$current2$paren.parentElement) === null || _table$current2$paren2 === void 0 ? void 0 : _table$current2$paren2.getBoundingClientRect().height);
    setStickyHeader(tableHeight > wrapperHeight);
  }, [table]);
  var checkIfSidebarIsSticky = (0,react.useCallback)(function () {
    var _table$current3, _table$current4, _table$current4$paren;

    var tableWidth = Number(table === null || table === void 0 ? void 0 : (_table$current3 = table.current) === null || _table$current3 === void 0 ? void 0 : _table$current3.getBoundingClientRect().width);
    var wrapperWidth = Number((_table$current4 = table.current) === null || _table$current4 === void 0 ? void 0 : (_table$current4$paren = _table$current4.parentElement) === null || _table$current4$paren === void 0 ? void 0 : _table$current4$paren.getBoundingClientRect().width);

    if (tableWidth > wrapperWidth) {
      setStickySidebar(true);
    } else {
      setStickySidebar(false);
    }
  }, [table]);
  (0,react.useEffect)(function () {
    if (table) {
      setTableRef(table);
      checkIfHeaderIsSticky();
      checkIfSidebarIsSticky();
    }
  }, [checkIfHeaderIsSticky, checkIfSidebarIsSticky, table]);
  (0,useResizeObserver/* default */.Z)({
    current: tableRef === null || tableRef === void 0 ? void 0 : (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.parentElement
  }, function () {
    checkIfHeaderIsSticky();
    checkIfSidebarIsSticky();
  });
  return {
    stickyHeader: stickyHeader,
    stickySidebar: stickySidebar
  };
};

/* harmony default export */ var TableBasic_useTableBasic = (useTableBasic);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableBasic/index.ts + 8 modules
var TableBasic = __webpack_require__(87960);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableBasic/Tr/index.ts + 2 modules
var Tr = __webpack_require__(74553);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TableBasic/Head/Head.views.tsx
var Head_views = __webpack_require__(48867);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/TablePricing.views.ts




var StyledTable = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TableBasic/* default */.ZP,  true ? {
  target: "e16pjazy0"
} : 0)(TableBasic.Td, "{text-align:center;padding:16px 24px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{padding:32px 24px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding:20px 24px;}}", Head_views/* Head */.F, ">", Tr/* TrView */.w, ">", TableBasic.Th, "{padding:24px 16px;vertical-align:top;text-align:center;min-width:170px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{min-width:", function (_ref4) {
  var columns = _ref4.columns;
  return 1 / columns * 100;
}, "%;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("md");
}, "{padding:24px;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{min-width:200px;}", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("xl");
}, "{min-width:max(", function (_ref8) {
  var columns = _ref8.columns;
  return 450 / columns;
}, "px, ", function (_ref9) {
  var columns = _ref9.columns;
  return 1 / columns * 50;
}, "%);}", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up("xxl");
}, "{min-width:", function (_ref11) {
  var columns = _ref11.columns;
  return 600 / columns;
}, "px;}}", Head_views/* Head */.F, ">", Tr/* TrView */.w, ">", TableBasic.Td, ":first-of-type,", Head_views/* Head */.F, ">", Tr/* TrView */.w, ">", TableBasic.Td, ":only-of-type,", Head_views/* Head */.F, ">", Tr/* TrView */.w, ">", TableBasic.Th, ":not(td ~ th):first-of-type{border:none;display:none;", function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.up("lg");
}, "{display:table-cell;min-width:500px;}", function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.up("xl");
}, "{width:40%;}}", Tr/* TrView */.w, ">", TableBasic.Th, "{padding:16px 24px;:focus-within,:hover{z-index:2;", function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakpoints.up("xl");
}, "{box-shadow:none;}}", function (_ref15) {
  var theme = _ref15.theme;
  return theme.breakpoints.up("sm");
}, "{padding:24px 16px;}}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/PricingTableContext.tsx


var _excluded = ["children", "columns", "stickyHeader", "stickySidebar"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var PricingTableContext = /*#__PURE__*/(0,react.createContext)(null);
var PricingTableContextProvider = function PricingTableContextProvider(_ref) {
  var children = _ref.children,
      columns = _ref.columns,
      stickyHeader = _ref.stickyHeader,
      stickySidebar = _ref.stickySidebar,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var value = (0,react.useMemo)(function () {
    return {
      columns: columns,
      stickyHeader: stickyHeader,
      stickySidebar: stickySidebar
    };
  }, [columns, stickyHeader, stickySidebar]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableContext.Provider, _objectSpread(_objectSpread({
    value: value
  }, rest), {}, {
    children: children
  }));
};
var usePricingTable = function usePricingTable() {
  var context = (0,react.useContext)(PricingTableContext);

  if (!context) {
    throw new Error("Pricing table context isn't available. Please set it via TablePricing component.");
  }

  return context;
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/TablePricing.tsx


var TablePricing_excluded = ["columns", "children", "scrollable"];

function TablePricing_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function TablePricing_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? TablePricing_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TablePricing_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var TablePricing = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var columns = _ref.columns,
      children = _ref.children,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TablePricing_excluded);

  var tableRef = (0,react.useRef)(null);

  var _useTableBasic = TableBasic_useTableBasic({
    table: tableRef
  }),
      stickyHeader = _useTableBasic.stickyHeader,
      stickySidebar = _useTableBasic.stickySidebar;

  (0,react.useImperativeHandle)(ref, function () {
    return tableRef.current;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTableContextProvider, {
    columns: columns,
    stickyHeader: stickyHeader,
    stickySidebar: stickySidebar,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTable, TablePricing_objectSpread(TablePricing_objectSpread({}, rest), {}, {
      scrollable: scrollable,
      columns: columns,
      ref: tableRef,
      children: children
    }))
  });
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Body/Body.tsx


var Body_excluded = ["children", "zebra"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Body = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      zebra = _ref.zebra,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic/* Body */.uT, Body_objectSpread(Body_objectSpread({
    ref: ref,
    zebra: zebra
  }, rest), {}, {
    children: children
  }));
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Body/index.ts

// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Header/Header.tsx


var Header_excluded = ["children", "sticky", "pinFirst"];

function Header_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Header_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Header_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Header_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var Header = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      sticky = _ref.sticky,
      _ref$pinFirst = _ref.pinFirst,
      pinFirst = _ref$pinFirst === void 0 ? true : _ref$pinFirst,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Header_excluded);

  var isGreaterThanHorizontalMobileResolution = (0,useMatchMedia/* default */.Z)("(min-height: 400px)", true);

  var _usePricingTable = usePricingTable(),
      stickySidebar = _usePricingTable.stickySidebar,
      stickyHeader = _usePricingTable.stickyHeader;

  var stickyFirstCell = pinFirst && isGreaterThanHorizontalMobileResolution && stickySidebar;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic/* Head */.Fb, Header_objectSpread(Header_objectSpread({
    ref: ref,
    sticky: sticky !== null && sticky !== void 0 ? sticky : isGreaterThanHorizontalMobileResolution && stickyHeader,
    shadow: stickyHeader
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Tr, {
      sticky: stickyFirstCell,
      shadow: stickyFirstCell,
      tokens: {
        pinZIndex: 2
      },
      children: children
    })
  }));
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Header/index.ts

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/constants.ts
var FIRST_COL_SPAN = 3;
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Row/Row.tsx


var Row_excluded = ["children", "header"];

function Row_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Row_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Row_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Row_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}










var Row = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      header = _ref.header,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Row_excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var isDesktopResolution = (0,useMatchMedia/* default */.Z)(theme.breakpoints.up("lg", false), true);

  var _usePricingTable = usePricingTable(),
      stickySidebar = _usePricingTable.stickySidebar,
      columns = _usePricingTable.columns;

  if (isDesktopResolution) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TableBasic.Tr, Row_objectSpread(Row_objectSpread({
      ref: ref,
      shadow: stickySidebar
    }, rest), {}, {
      children: [header && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Th, {
        colSpan: FIRST_COL_SPAN,
        children: header
      }), children]
    }));
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Tr, Row_objectSpread(Row_objectSpread({}, rest), {}, {
      children: header && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Th, {
        colSpan: FIRST_COL_SPAN + columns,
        children: header
      })
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Tr, Row_objectSpread(Row_objectSpread({
      ref: ref
    }, rest), {}, {
      children: children
    }))]
  });
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Row/index.ts

// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/RowHeader/RowHeader.views.ts

var RowHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e13lxhs90"
} : 0)("display:flex;align-items:center;gap:12px;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";margin:0;", function (_ref2) {
  var theme = _ref2.theme,
      variantMobile = _ref2.variantMobile;
  return theme.typography[variantMobile].css;
}, ";", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{", function (_ref4) {
  var theme = _ref4.theme,
      variantDesktop = _ref4.variantDesktop;
  return theme.typography[variantDesktop].css;
}, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/RowHeader/RowHeader.tsx


var RowHeader_excluded = ["children", "icon", "tokens"];

function RowHeader_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function RowHeader_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? RowHeader_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RowHeader_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseRowHeader = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      icon = _ref.icon,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, RowHeader_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RowHeader, RowHeader_objectSpread(RowHeader_objectSpread(RowHeader_objectSpread({}, tokens), rest), {}, {
    ref: ref,
    children: [children, icon]
  }));
});
var RowHeader_RowHeader = (0,useDesignTokens/* withDesignTokens */.Y)(BaseRowHeader, function () {
  return {
    variantMobile: "textBoldSmall",
    variantDesktop: "h5"
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/RowHeader/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/RowSubHeader/RowSubHeader.views.ts


var RowSubHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RowHeader_RowHeader,  true ? {
  target: "efoodvf0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.textRegularSmall;
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{", function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.pSmall.css;
}, ";}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{", function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.h6.css;
}, ";margin-left:24px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/RowSubHeader/RowSubHeader.tsx


var RowSubHeader_excluded = ["children", "icon"];

function RowSubHeader_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function RowSubHeader_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? RowSubHeader_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RowSubHeader_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var RowSubHeader_RowSubHeader = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      icon = _ref.icon,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, RowSubHeader_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RowSubHeader, RowSubHeader_objectSpread(RowSubHeader_objectSpread({
    ref: ref,
    icon: icon
  }, rest), {}, {
    children: children
  }));
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/RowSubHeader/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/LightRow/LightRow.views.ts


var LightRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TableBasic.Tr,  true ? {
  target: "eol2r9c0"
} : 0)("&,", TableBasic.Th, ",", TableBasic.Td, "{background-color:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, "!important;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/LightRow/LightRow.tsx


var LightRow_excluded = ["children", "tokens"];

function LightRow_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function LightRow_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? LightRow_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LightRow_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseLightRow = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, LightRow_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LightRow, LightRow_objectSpread(LightRow_objectSpread(LightRow_objectSpread({
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var LightRow_LightRow = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLightRow, function (_, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/LightRow/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/EmptyRow/EmptyRow.tsx


function EmptyRow_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function EmptyRow_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? EmptyRow_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EmptyRow_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}










var EmptyRow = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var isDesktopResolution = (0,useMatchMedia/* default */.Z)(theme.breakpoints.up("lg", false), true);

  var _usePricingTable = usePricingTable(),
      columns = _usePricingTable.columns,
      stickySidebar = _usePricingTable.stickySidebar;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LightRow_LightRow, EmptyRow_objectSpread(EmptyRow_objectSpread({
    ref: ref,
    shadow: stickySidebar
  }, props), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Th, {
      as: "td",
      colSpan: FIRST_COL_SPAN
    }), isDesktopResolution && Array.from({
      length: columns
    }).map(function (_, i) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Td, {}, i);
    })]
  }));
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/EmptyRow/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/HeaderCell/HeaderCell.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var HeaderCell = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10xogop2"
} : 0)( true ? {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column"
} : 0);
var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10xogop1"
} : 0)( true ? {
  name: "10e08q6",
  styles: "margin:0 0 24px"
} : 0);
var Hint = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10xogop0"
} : 0)( true ? {
  name: "fvlpzw",
  styles: "margin:16px 0 0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/HeaderCell/HeaderCell.tsx


var HeaderCell_excluded = ["title", "hint", "children", "tokens", "headingVariant"];

function HeaderCell_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function HeaderCell_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? HeaderCell_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HeaderCell_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseHeaderCell = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      hint = _ref.hint,
      children = _ref.children,
      tokens = _ref.tokens,
      _ref$headingVariant = _ref.headingVariant,
      headingVariant = _ref$headingVariant === void 0 ? "h4" : _ref$headingVariant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, HeaderCell_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Th, HeaderCell_objectSpread(HeaderCell_objectSpread({
    ref: ref,
    as: title ? "th" : "td",
    colSpan: title ? undefined : FIRST_COL_SPAN
  }, rest), {}, {
    children: (hint || title) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderCell, {
      children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
        variant: headingVariant,
        tokens: {
          color: tokens.headingColor
        },
        tag: "span",
        children: title
      }), children, hint && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hint, {
        variant: "formHint",
        tokens: {
          color: tokens.color
        },
        children: hint
      })]
    })
  }));
});
var HeaderCell_HeaderCell = (0,useDesignTokens/* withDesignTokens */.Y)(BaseHeaderCell, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      headingColor: theme.palette.brand.darkAcai[700],
      color: theme.palette.brand.darkAcai[400]
    };
  },
  dark: function dark(theme) {
    return {
      headingColor: theme.palette.brand.darkAcai[700],
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      headingColor: theme.palette.twilio.gray[100],
      color: theme.palette.twilio.gray[50]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/HeaderCell/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/SectionHeader/SectionHeader.views.ts

var SectionHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "em3izsb0"
} : 0)("color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.h4.css;
}, ";", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{", function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.h3.css;
}, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/SectionHeader/SectionHeader.tsx


var SectionHeader_excluded = ["children", "tokens"];

function SectionHeader_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SectionHeader_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SectionHeader_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SectionHeader_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var BaseSectionHeader = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SectionHeader_excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var isDesktopResolution = (0,useMatchMedia/* default */.Z)(theme.breakpoints.up("lg", false), true);

  var _usePricingTable = usePricingTable(),
      stickySidebar = _usePricingTable.stickySidebar,
      columns = _usePricingTable.columns;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LightRow_LightRow, SectionHeader_objectSpread(SectionHeader_objectSpread({
    ref: ref,
    shadow: isDesktopResolution && stickySidebar
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Th, {
      colSpan: FIRST_COL_SPAN,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader, SectionHeader_objectSpread(SectionHeader_objectSpread({}, tokens), {}, {
        children: children
      }))
    }), isDesktopResolution && Array.from({
      length: columns
    }).map(function (_, i) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Td, {}, i);
    })]
  }));
});
var SectionHeader_SectionHeader = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSectionHeader, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/SectionHeader/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Cell/Cell.views.ts

var Cell = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nn4tqt0"
} : 0)("color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.textRegularSmall.css;
}, ";", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{", function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.pSmall.css;
}, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Cell/Cell.tsx


var Cell_excluded = ["children", "tokens"];

function Cell_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Cell_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Cell_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Cell_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseCell = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Cell_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableBasic.Td, Cell_objectSpread(Cell_objectSpread({}, rest), {}, {
    ref: ref,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cell, Cell_objectSpread(Cell_objectSpread({}, tokens), {}, {
      children: children
    }))
  }));
});
var Cell_Cell = (0,useDesignTokens/* withDesignTokens */.Y)(BaseCell, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/Cell/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/TablePricing/index.tsx










TablePricing.displayName = "TablePricingBase";
Header.displayName = "TablePricing.Header";
HeaderCell_HeaderCell.displayName = "TablePricing.HeaderCell";
Body.displayName = "TablePricing.Body";
SectionHeader_SectionHeader.displayName = "TablePricing.SectionHeader";
Row.displayName = "TablePricing.Row";
RowHeader_RowHeader.displayName = "TablePricing.RowHeader";
RowSubHeader_RowSubHeader.displayName = "TablePricing.RowSubHeader";
Cell_Cell.displayName = "TablePricing.Cell";
EmptyRow.displayName = "TablePricing.EmptyRow";


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 73889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useResizeObserver_useResizeObserver; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(97209);
;// CONCATENATED MODULE: ../../libs/utils/useResizeObserver/useResizeObserver.ts


/**
 * The useResizeObserver reports changes to the dimensions of an element's content or border box
 * @param ref - A ref to the element to observe
 * @param fn - A callback function called when size of the observed element change
 */

var useResizeObserver = function useResizeObserver(ref, fn) {
  (0,react.useEffect)(function () {
    var resizeObserver = new ResizeObserver_es/* default */.Z(function () {
      fn();
    });

    if (ref !== null && ref !== void 0 && ref.current) {
      resizeObserver.observe(ref.current);
    }

    return function () {
      resizeObserver.disconnect();
    };
  }, [fn, ref]);
};

/* harmony default export */ var useResizeObserver_useResizeObserver = (useResizeObserver);
;// CONCATENATED MODULE: ../../libs/utils/useResizeObserver/index.ts


/***/ })

}]);